<div class="invite-btn" [ngClass]="{ '--light': isLight() }" (click)="showInviteModal()">
    <div class="__icon">
        <fa-icon [icon]="['tg', 'plus']"></fa-icon>
    </div>
    <div class="__title">Invite!</div>
</div>
